<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      志愿单预览
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <jibenxinxi></jibenxinxi>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <div class="wenz_l">
              <img src="../images/geren16.png">{{$utils.getShowYear()}}年志愿生成表
            </div>
            <div class="wenz_r">
              <div class="wenz_r_l" style="background: #00B54F;" @click="save">
                保存志愿单
              </div>
              <!-- <div class="wenz_r_l" >
                导出志愿单
              </div>
              <div class="wenz_r_r">
                打印志愿单
              </div> -->
            </div>
          </div>
          <!-- 志愿生成表 -->
          <div class="generateAssess ">
            <div class="assess">
              <span :style="$utils.getrateStyle(zyrate)">{{zyrate}}</span>
              <h5 :style="$utils.getrateStyle(zyrate)">评估得分</h5>
            </div>
            <em></em>
            <div class="list">
              <div class="item">
                学生姓名：<span>{{userInfo.userName}}</span>
              </div>
              <div class="item">
                分数：<span>{{scoreInfo.score}}分</span>
              </div>
              <div class="item">
                位&nbsp;&nbsp;&nbsp;次：<span>{{rank}}</span>
              </div><br>
              <div class="item">
                选考科目：<span>{{SUBJECTTYPEOBJ[scoreInfo.scoreSubject]}}</span>
              </div>
              <div class="item">
                批次：<span>{{userZhiYuanBatch.provincialBatch}}</span>
              </div>
              <div class="item">
                省控线：<span>{{userZhiYuanBatch.provincialScore}}分</span>
              </div>

            </div>
            <div class="list" style="flex-direction: column;">
              <div class="item1">
                已选志愿：<span>{{list.length}}</span>
              </div>
              <div class="item1">
                已选院校：<span>{{collegenum}}</span>
              </div>
              <div class="item1">
                已选专业：<span>{{majornum}}</span>
              </div>

            </div>
          </div>
          <ul class="generateList">
            <li v-for="(item,index) in list" :key="index">
              <div class="xh" :style="$utils.getrateStyle(map[item].rate,1)">{{index+1}}</div>
              <div class="item">
                <div class="itemLeft flex-items" style="min-height: 148px;">
                  <div class="t1" v-if="map[item].score!=null&&map[item].score.length!=0">
                    <span :style="$utils.getrateStyle(map[item].rate)">{{map[item].rate}}%</span>
                    <h5 :style="$utils.getrateStyle(map[item].rate)">概率</h5>
                  </div>
                  <div class="t1" v-else>
                    <div style="width: 55px;color: #F53824;line-height: 24px; font-size: 12px;">新增专业不做推荐自主填报</div>
                  </div>
                  <div class="t2" >
                    <h4 style="font-size: 16px;width: 500px;display: flex;justify-content: start;">
                    <span class="myspan" v-if="$utils.getlocalStorage('showcode')"
                    style="border: 1px solid #F53824;background-color: white;border-radius: 18px;
                    padding: 0px 10px;font-size: 12px;margin-right: 10px;">
                      {{getempty(map[item].collegeCode)}}
                    </span>
                    {{map[item].collegeName}}
                      <span class="myspan" v-if="map[item].collegeInfo!=null&&map[item].collegeInfo!=''"
                        style="margin-left:10px;">{{map[item].collegeInfo}}</span>
                        <div style="margin-left: 10px;">
                            <icollege :item="map[item]"></icollege>
                        </div>
                      <!-- <div class="itemRigth " style="margin-left: auto;">
                        <div class="flex-items shipei">
                          <span class="del" style="font-size: 12px; width: 80px;height: 20px;" @click="del(index,item,map[item].type)">删除志愿</span>
                        </div>
                      </div> -->
                    </h4>

                    <div class="flex-items shipeishangxia" style="margin-top:5px;width: 500px;justify-content: start;">
                      <div class="dm" style="font-size: 12px;">
                        <span style="color: black;">{{AREA_OBJ[map[item].collegeArea]}} /
                        {{ map[item].collegeSubject }} /
                        <span :style="{color:map[item].collegeNature == 1?'':'red'}">{{map[item].collegeNature == 1?'公立':'民办'}}</span>
                        <span v-if="map[item].college!=null&&map[item].college.area!=null"> / {{ map[item].college.area }}</span>
                        </span>
                        <p>{{map[item].collegeNature !=1?'民办':''}}
                          {{map[item].collegeLevel!=null&&map[item].collegeLevel!=""?"/"+map[item].collegeLevel.replace(/,/g,'/'):''}}
                        </p>
                      </div>
                    </div>
                    <div class="flex-items shipeishangxia" v-if="tianbaoType != 1" style="width: 500px;justify-content: start;font-size: 13px;line-height: 30px;">
                      <div>分组：<span style="color: #F53824;">{{map[item].groupname}}</span><span style="color: #666666;margin-left: 10px;">({{map[item].collegeInfo}}111)</span></div>
                      <div style="margin-left: 20px;">选科：<span style="color: #F53824;">{{map[item].xuankeStr}}</span></div>
                    </div>

                    <div class="flex-items shipeishangxia" style="width: 500px;" v-if="tianbaoType == 1">
                      <div class="dm">
                        <div v-if="tianbaoType == 2" style="background-color: #29A7E1;border-radius: 10px;height: 20px;padding: 0px 5px;margin-right: 5px;">
                          <span style="font-size: 12px;line-height: 20px;color: #ffffff;">{{map[item].groupName}}</span>
                        </div>
                        <div style="background-color: red;color: #ffffff;
                        height: 18px;line-height: 18px; font-size: 10px;padding: 0 5px;border-radius: 8px;margin-right: 10px;"
                        >{{map[item].majorCode}}</div>

                        <p style="margin-right:10px">
                          {{map[item].majorName}}
                        </p>
                        <p style="margin-right:10px; color:#F53824" v-if="map[item].studyMoney!=null&&map[item].studyMoney!=''">
                          学费 : {{map[item].studyMoney}}
                        </p>
                        <imajor :item="map[item]"></imajor>
                      </div>

                      <div style="margin-right: 125;font-size: 12px;">当年计划：<span
                          style="font-size:14px;color: #F53824;margin-right: 10px;">{{getempty(map[item].planNum)}}</span>
                          <br/><span style="color: #F53824;">( {{map[item].xuankeStr}} )</span>
                      </div>
                    </div>

                    <div class="flex-items majorinfo" style="width: 500px;" v-if="tianbaoType == 1">
                      <p class="info">{{map[item].majorInfo}}</p>
                    </div>

                  </div>
                  <yiscore  :score="map[item].score" :year="scoreYear" v-if="map[item].flag" style="width: 395px;margin-left: 0px;"></yiscore>
                </div>
                <div class="itemRigth">
                  <div class="flex-items" style="flex-direction: column;">
                    <a class="btn" style="width: 60px;" @click="updatesort(index,true)">上调</a>
                    <a class="del" style="margin-top: 15px;margin-bottom: 15px;" @click="deleteZy(index,item,map[item].type)">删除</a>
                    <a class="btn" style="width: 60px;" @click="updatesort(index,false)">下调</a>
                    <!-- <a class="update">添加</a> -->
                  </div>
                </div>
              </div>
              <div id="box" class="zhankaiNeirong" v-if="!map[item].show">
                <div class="zymajor" v-for="(major,index1) in map[item].list">
                  <div class="text" style="width:70px;">
                    <div class="t1" v-if="major.score!=null&&major.score.length!=0">
                      <span style="font-size: 18px;" :style="$utils.getrateStyle(major.rate)">{{major.rate}}%</span>
                      <h5>概率</h5>
                    </div>
                    <div class="t1" v-else>
                       <div style="width: 55px;color: #F53824;line-height: 24px; font-size: 12px;">新增专业不做推荐自主填报</div>
                    </div>
                  </div>
                  <div style="flex-direction: column;justify-content: space-between;width: 760px;">
                    <div class="topBox">
                      <div class=" flex-items" style="min-width: 340px; flex-direction: column;display: flex;justify-content: space-evenly;align-items: flex-start;">
                        <div style="display: flex;flex-direction: row;
                          width: 335px;
                          align-items: center;justify-content: space-between;">
                            <h4>{{major.majorName}}</h4>
                            <imajor :item="major"></imajor>
                          </div>
                          <div>
                            <div style="flex-direction: row;display: flex; justify-content: space-between;width: 335px;">
                              <div style="margin-top: 10px;" v-if="$utils.getlocalStorage('showcode')">代码：<b style="color: #F53824;">{{getempty(major.majorCode)}}</b></div>
                              <div style="margin-top: 10px;" v-if="major.studyMoney!=null&&major.studyMoney!=null">学费：<b style="color: #F53824;">{{major.studyMoney}}</b></div>
                              <div style="margin-top: 10px;" >计划招生：<b style="color: #F53824;">{{getempty(major.planNum)}}</b></div>
                            </div>
                          </div>
                          <p style="width:360px;color: #999999;" v-if="major.majorInfo!=null&&major.majorInfo!=''">
                          {{major.majorInfo}}</p>
                        </div>
                        <yiscore :score="major.score" :year="scoreYear" v-if="major.flag" style="width: 395px;margin-left: 0px;"></yiscore>
                    </div>

                  </div>
                  <div class="flex-end" style="width:60px;">
                    <div class="px" style="width: 60px;padding-left: 5px;" v-if="map[item].list.length != 1">
                      <!-- <a ><img src="../images/s.png"></a> -->
                      <span class="del" style="margin-left:0;" @click="changMajorsort(index1,item,map[item].type,true)"><img src="../images/x.png"
                          style="transform: rotate(180deg);"></span>
                      <span class="del" style="margin-top: 5px;margin-bottom:5px; margin-left: 0;" v-if="map[item].list.length != 1"
                            @click="delMajor(index,index1,item,map[item].type)">删除专业</span>
                      <span  class="del" style="margin-left:0;" @click="changMajorsort(index1,item,map[item].type,false)">
                        <img src="../images/x.png"></span>
                    </div>
                    <!-- <span class="del" style="margin-top: 5px;"
                      @click="delMajor(index,index1,item,map[item].type)">添加专业</span> -->

                  </div>
                </div>
              </div>
              <span v-if="tianbaoType != 1" class="zhankai"
                @click="openShutManager(map[item].id)">已选专业(<span>{{map[item].list.length}}</span>)个<img
                  src="../images/icon_xia.png"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showcaozuo">
      <div class="maskA">
        <div class="maskAA">
          <p>使用须知</p>
          <!-- <img @click="showcaozuo = false" src="../../../src/assets/img/cha.png" /> -->
        </div>
        <div class="ANAN1">
          <figure>
            <figcaption>考生在取得自己高考成绩前模拟生成的志愿单不得作为志愿填报的参考，考生成绩公布后，考生按自己真实高考成绩生成的志愿单可作为高考志愿填报的参考。</figcaption>
          </figure>
          <figure>
            <figcaption>本系统提供的志愿单，仅作为考生志愿填报的参考，考生最终志愿的确定以自己最终决定为准。
              本系统提供志愿单中的院校及专业代码，仅供参考，最终请以考生所在省招生考试院公布的招生计划为准。</figcaption>
          </figure>
          <figure>
            <figcaption style="font-weight: 800;">特别提醒：本系统为志愿辅助生成平台，不是各省招生考试院的志愿填报平台，考生在本系统生成志愿后，必须要去考生所在省招生考试院规定的志愿填报网站填报高考志愿，切记！</figcaption>
          </figure>
          <figure class="wenz_r" style="flex-direction: row;justify-content: center;">
              <el-button type="danger" :disabled="loading" style="width: 180px;text-align: center;" @click="showcaozuo = false">
                我已阅读此内容<b v-if="itime!=0">&nbsp;(  {{itime}} s )</b>
              </el-button>
          </figure>
        </div>
      </div>
    </div>
    <item7></item7>
    <toast :title="title" :message="message" @close="close" v-if="toastflag" :flag="toastflag" :fun="fun"
      @to="to" btn="que"></toast>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import jibenxinxi from '../../components/jibenxinxi.vue'
  import toast from '../../components/toast.vue'
  import icollege from '../../components/icollege.vue'
  import imajor from '../../components/imajor.vue'
  import yiscore from '../yiscore.vue'

  export default {
    name: "",
    components: {
      vHeader,
      item7,
      jibenxinxi,
      toast,
      yiscore,
      icollege,
      imajor
    },
    data() {
      return {
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage('SUBJECTTYPEOBJ'),
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        scoreInfo: this.$utils.getlocalStorage('scoreInfo'),
        userInfo: this.$utils.getlocalStorage('userInfo'),
        areaInfo: this.$utils.getlocalStorage('areaInfo'),
        userZhiYuanBatch: this.$utils.getlocalStorage('userZhiYuanBatch'),
        zyrate: 0,
        list: [],
        map: {},
        collegenum: 0,
        majornum: 0,
        title: "",
        message: "",
        toastflag: false,
        fun: '',
        showcaozuo: true,
        scoreYear:2023,
        itime:8,
        loading:true,
        rank:0
      }
    },
    mounted() {
      console.log('zyd')
      let obj = this.$utils.getlocalStorage('ZhiYuanDanObj')
      let _this = this;
      if (obj != null) {
        this.list = obj.ids;
        this.map = obj.map;
        this.scoreYear = obj.scoreYear
        // this.batchscore =obj.provincialScore,
        this.rank = obj.rank
      }
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = '';
      document.addEventListener("touchmove", mo, false);
      this.getAlldata();
      let timer = setInterval(()=>{

        _this.itime--;
        if(_this.itime == 0){
          clearInterval(timer);
          _this.loading = false;
          // _this.showcaozuo = false;
        }
      },1000)
    },
    methods: {
      close(){
        this.toastflag = false;
      },
      getAlldata() {
        let _this = this;
        let college = new Set();
        let major = new Set();
        this.list.forEach(function(id) {
          let item = _this.map[id]
          _this.map[id].flag=true;
          college.add(item.collegeId)
          if (_this.tianbaoType != 1) {
            item.list.forEach(function(majorinfo) {
              majorinfo.flag = true;
              major.add(majorinfo.majorId)
            })
          } else {
            major.add(item.majorId)
          }
        })
        this.collegenum = college.size
        this.majornum = major.size
        this.zyrate = this.map[this.list[this.list.length - 1]].rate;
      },
      deleteZy(index, zyid, type) {
        this.list.splice(index, 1);
        delete this.map[zyid];
        let obj = this.$utils.getlocalStorage("ZhiYuan" + type);
        obj.ids.splice(obj.ids.indexOf(zyid), 1);
        delete obj.map[zyid];
        this.$utils.setlocalStorage("ZhiYuan" + type, obj);
        this.$utils.setlocalStorage("ZhiYuanDanObj", {
          ids: this.list,
          map: this.map
        });
        this.getAlldata();

      },
      delMajor(index, index1, zyid, type) {
        this.map[zyid].ids.splice(index1, 1);
        this.map[zyid].list.splice(index1, 1);
        let ZhiYuan = this.$utils.getlocalStorage("ZhiYuan" + type);
        ZhiYuan.map[zyid] = this.map[zyid]
        this.$utils.setlocalStorage("ZhiYuan" + type, ZhiYuan);
        this.$utils.setlocalStorage("ZhiYuanDanObj", {
          ids: this.list,
          map: this.map
        });
        this.getAlldata();
      },
      to() {
        console.log(0)
        if(this.$utils.getlocalStorage("volunteerTableInfo")){
          this.$router.push('/grzx_yhzybgd_lao')
        } else {
          this.$utils.removelocalStorage("zyd_selectId")
          this.$router.push('/grzx_wodezhiyuan')
        }


      },
      save() {
        let list = []
        let _this = this;
        this.list.forEach(function(id) {
          list.push(_this.map[id])
        })
        let obj = {}
        // if(this.tianbaoType == 0){
        //   obj.spare5 = this.$utils.getlocalStorage("userZhiYuanBatch").spare1
        // }

        if(this.$utils.getlocalStorage("volunteerTableInfo")){
          obj = this.$utils.getlocalStorage("volunteerTableInfo")
          obj.volunteerMajor = this.majornum;
          obj.volunteerCollege = this.collegenum;
          obj.volunteerNum = this.list.length;
          obj.spare5 = this.scoreYear;
          obj.dataStr = JSON.stringify(list)
          this.$utils.setlocalStorage("volunteerTableInfo",obj);
          this.$req.update("volunteerTable", obj).then(function(response) {
            if (response.status == "0") {
              _this.title = "温馨提示"
              _this.toastflag = true
              _this.fun="close"
              _this.message = "您的志愿信息保存成功"
              _this.fun = "to"
            } else {
              _this.title = "温馨提示"
              _this.toastflag = true
              _this.fun="close"
              _this.message = response.message
            }
          })
        } else {
          obj = {
            volunteerName: "未定义",
            volunteerRate: this.zyrate,
            volunteerScore: this.scoreInfo.score,
            volunteerScoreRank: this.scoreInfo.scoreRank,
            spare: this.scoreInfo.scoreArea,
            spare1: this.scoreInfo.userId,
            spare2: this.userZhiYuanBatch.provincialYear,
            spare3: this.userInfo.userName,
            spare4: this.$utils.getlocalStorage("userZhiYuanBatch").provincialScore,
            volunteerMajor: this.majornum,
            volunteerCollege: this.collegenum,
            volunteerXuanke: this.getxuanke(this.scoreInfo.scoreXuanke),
            volunteerNum: this.list.length,
            volunteerSubject: this.scoreInfo.scoreSubject,
            volunteerBatch: this.$utils.getlocalStorage("userZhiYuanBatch").provincialBatch,
            volunteerYear: new Date().getFullYear(),
            dataStr: JSON.stringify(list),
            spare5:this.scoreYear
            // spare5:this.$utils.getlocalStorage("user/ZhiYuanBatch").spare1

          }
          this.$req.insert("volunteerTable", obj).then(function(response) {
            if (response.status == "0") {
              _this.title = "温馨提示"
              _this.toastflag = true
              _this.fun="close"
              _this.message = "您的志愿信息保存成功"
              _this.fun = "to"
            } else {
              _this.title = "温馨提示"
              _this.toastflag = true
              _this.fun="close"
              _this.message = response.message
            }
          })
        }


      },
      getxuanke() {
        let xuanke = null;
        let str = "";
        if(this.scoreInfo.scoreXuanke){
          xuanke = this.scoreInfo.scoreXuanke.split(",");
          xuanke.forEach(function(item) {
            switch (item) {
              case 'wl':
                str += "物+";
                break;
              case 'ls':
                str += "历+";
                break;
              case 'hx':
                str += "化+";
                break;
              case 'sw':
                str += "生+";
                break;
              case 'dl':
                str += "地+";
                break;
              case 'zz':
                str += "政+";
                break;
              case 'xxjs':
                str += "信息+";
                break;
            }
          })
          return str.substring(0, str.length - 1)
        }
         return str;

      },
      updatesort(index, flag) {
        let _this = this;
        if (this.list.length != 1) {
          if ((flag && index != 0) || (!flag && index != this.list.length - 1)) {
            let obj = this.list[index]
            let n = index + 1
            if (flag) {
              //上调
              n = index - 1
            }
            this.list[index] = this.list[n]
            this.list[n] = obj
            this.map[this.list[index]].flag= false;
            this.map[this.list[n]].flag= false;
            this.map[this.list[index]].show= true;
            this.map[this.list[n]].show= true;
            setTimeout(function(){
              _this.map[_this.list[index]].flag= true;
              _this.map[_this.list[n]].flag= true;
              _this.$forceUpdate()
            },0)
            this.$nextTick(()=>{

            })
          }
        }
        this.$utils.setlocalStorage("ZhiYuanDanObj", {
          ids: this.list,
          map: this.map
        });
        // this.getAlldata();
        this.$forceUpdate()
        // console.log(this.list)
      },
      changMajorsort(index, zyid, type, flag) {
        if ((flag && index != 0) || (!flag && index != this.map[zyid].ids.length - 1)) {
          let obj = this.map[zyid].list[index]
          let id = this.map[zyid].ids[index]
          let n = index + 1
          if (flag) {
            //上调
            n = index - 1
          }
          this.map[zyid].list[index] = this.map[zyid].list[n]
          this.map[zyid].list[n] = obj

          this.map[zyid].list[index].flag = false;
          this.map[zyid].list[n].flag = false;
          this.$nextTick(()=>{
            this.map[zyid].list[index].flag = true;
            this.map[zyid].list[n].flag = true;
          })

          this.map[zyid].ids[index] = this.map[zyid].ids[n]
          this.map[zyid].ids[n] = id
          this.$forceUpdate()
          let ZhiYuan = this.$utils.getlocalStorage("ZhiYuan" + type);
          ZhiYuan.map[zyid] = this.map[zyid]
          this.$utils.setlocalStorage("ZhiYuan" + type, ZhiYuan);
          this.$utils.setlocalStorage("ZhiYuanDanObj", {
            ids: this.list,
            map: this.map
          });
        }
      },


      getempty(str) {
        if (str == null || str == '') {
          return '--';
        }
        return str;
      },
      openShutManager(id) {
        this.map[id].show = !this.map[id].show
      },
    }


  }
</script>

<style scoped>
  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 700px;
    height: 380px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 700px;
    height: 64px;
    background-image: url("../../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN1 {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */

    height: 380px;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANAN1 figure {
    display: flex;
    margin-bottom: 18px;

  }

/*  .ANAN1 figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  } */

  .ANAN1 figure figcaption {
    text-indent: 1cm;
    font-size: 16px;
    /* line-height: 30px; */
    color: #F53824;
    font-family: PingFang SC;
    font-weight: 500;
  }






  .generateList {
    margin-top: 20px;
  }

  .majorinfo {
    margin-top: 5px;
  }

  .majorinfo .info {
    font-size: 12px;
    color: #999999 !important;
  }

  .majorinfo p {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 25px;
    color: #666666;
    margin-left: 0px !important;
  }

  .zhankaiNeirong {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .zymajor {
    width: 95%;
  }



  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 90px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 0px 0;
    box-sizing: border-box;
    background: rgba(251, 251, 251, 1);
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 290px;
  }



  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1070px;
    /* height: 878px; */
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  /* 新改的 */
  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    justify-content: space-between;
  }

  .mainr_top .wenz_l {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top .wenz_l img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .wenz_r {
    display: flex;
    align-items: center;
  }

  .wenz_r .wenz_r_l {
    margin-right: 20px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    background: linear-gradient(131deg, #F45D26 0%, #F53824 100%);
    box-shadow: 0px 0px 10px rgba(245, 56, 36, 0.4);
    opacity: 1;
    border-radius: 5px;
  }

  .wenz_r .wenz_r_r {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    background: linear-gradient(131deg, #29A7E1 0%, #249AD1 100%);
    box-shadow: 0px 0px 10px rgba(41, 167, 225, 0.4);
    opacity: 1;
    border-radius: 5px;
  }



  /* 新改的 */

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }


  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }



  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/tianbao/zyd.vue